import * as React from 'react'
import * as moment from 'moment'
import { Overlay, Tooltip } from 'react-bootstrap'
import { LoanQueryResult } from './queries/LoanQuery'
import { calculateRequiredPayment } from '../utils/transactions'
import { moneyFormat } from '../utils/format'

type Loan = Exclude<LoanQueryResult['loan'], null>

interface ToPayOverlayProps {
  loan?: Loan
  loans?: Loan[]
  label?: string
  date: moment.Moment
}

interface ToPayOverlayState {
  toggled: boolean
}

export class ToPayOverlay extends React.Component<
  ToPayOverlayProps,
  ToPayOverlayState
> {
  private spanRef: React.RefObject<HTMLSpanElement>

  constructor(props: ToPayOverlayProps) {
    super(props)

    this.state = { toggled: false }
    this.spanRef = React.createRef()

    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.getTarget = this.getTarget.bind(this)
  }

  getTarget() {
    return this.spanRef.current
  }

  onMouseEnter() {
    this.setState({ toggled: true })
  }

  onMouseLeave() {
    this.setState({ toggled: false })
  }

  render() {
    let required = 0
    let amount = 0

    if (this.props.loan != null) {
      required = calculateRequiredPayment(this.props.loan, this.props.date)
      amount = this.props.loan.state.amount || 0
    } else if (this.props.loans != null) {
      required = this.props.loans.reduce(
        (acc, loan) => acc + calculateRequiredPayment(loan, this.props.date),
        0
      )
      amount = this.props.loans.reduce(
        (acc, loan) => acc + (loan.state.amount || 0),
        0
      )
    }

    return (
      <div style={{ position: 'relative' }}>
        {this.props.label != null ? `${this.props.label}: ` : ''}
        <span
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          ref={this.spanRef}
        >
          {moneyFormat(required)}
        </span>
        <Overlay
          container={this}
          target={this.getTarget}
          show={this.state.toggled}
          placement={this.props.label != null ? 'top' : 'left'}
        >
          <Tooltip>
            Jistina: {moneyFormat(amount)} / Úroky:{' '}
            {moneyFormat(required - amount)}
          </Tooltip>
        </Overlay>
      </div>
    )
  }
}

export default ToPayOverlay



// WEBPACK FOOTER //
// ./src/components/ToPayOverlay.tsx